module.exports = __webpack_public_path__ + "img/hospital-ward.1dd04be3.jpg";